"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Channel = void 0;
var Channel;
(function (Channel) {
    Channel["VOICE"] = "VOICE";
    Channel["CHAT"] = "CHAT";
})(Channel = exports.Channel || (exports.Channel = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhbm5lbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jaGFubmVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksT0FHWDtBQUhELFdBQVksT0FBTztJQUNmLDBCQUFlLENBQUE7SUFDZix3QkFBYSxDQUFBO0FBQ2pCLENBQUMsRUFIVyxPQUFPLEdBQVAsZUFBTyxLQUFQLGVBQU8sUUFHbEIiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBDaGFubmVsIHtcbiAgICBWT0lDRSA9ICdWT0lDRScsXG4gICAgQ0hBVCA9ICdDSEFUJyxcbn1cbiJdfQ==